<template>
  <div>
    <canvas :id='title' width="80%" height="80%"></canvas>
  </div>  
</template>

<script>
import Chart from 'chart.js'

export default {
  props: {
    update: '',
    title: '',
    labels: {
      default: {}
    },
    portfolio: {
      default: {}
    },
    baseCurr: {
      default: {}
    }
  },
  data () {
    return {
      chartdata: {
        type: 'doughnut',
        data: {
          labels: this.labels,
          datasets: [{
            data: this.portfolio,
            backgroundColor: [
              'rgba(255, 99, 132, 0.2)',
              'rgba(54, 162, 235, 0.2)',
              'rgba(255, 159, 64, 0.2)',
              'rgba(0, 123, 0, 0.2)',
              'rgba(200, 123, 200, 0.2)',
              'rgba(0, 180, 180, 0.2)',
              'rgba(0, 74, 74, 0.2)',
              'rgba(220, 200, 74, 0.2)'
            ]
          }]
        },
        options: {
          responsive: true,
          legend: {
            display: false
          },
          tooltips: {
            callbacks: {
              label: function (tooltipItem, data) {
                // var label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index] || ''
                // label += tooltipItem.data + 'BTC'

                var label = data.labels[tooltipItem.index] || ''

                // var label = this.labels[tooltipItem.index]
                console.log('tt', tooltipItem.index)
                console.log(data)
                return ' ' + label
              }
            },
            bodyFontSize: 25,
            bodySpacing: 4,
            backgroundColor: 'rgba(73,73,73,0.5)',
            xPadding: 12,
            yPadding: 12
          }
        }
      }
    }
  },
  watch: {
    update: function () {
      if (this.update) {
        this.updateChart()
        this.$emit('updated', this.update)
      } else {
        console.log('no update')
      }
    }
  },
  methods: {
    updateChart () {
      console.log('updateing with:', this.chartdata)
      this.chartdata.data.labels = this.labels
      this.chartdata.data.datasets[0].data = this.portfolio
      this.myChart.update(this.chartdata)
    }
  },
  mounted () {
    console.log(this.chartdata)
    const ctx = document.getElementById(this.title)
    this.myChart = new Chart(ctx, this.chartdata)
    console.log('initial:', this.chartdata.data)
  }
}
/* eslint-enable  */
</script>

<style scoped>

input, textarea{
    font-family: 'Avenir';
    background-color:rgb(78, 78, 78);
    color: #FFF;
}
</style>


// WEBPACK FOOTER //
// src/components/btr-donut.vue